export default __webpack_public_path__ + "static/media/mountaineer.7a3135f3.png";